import React, { FunctionComponent } from 'react';
import { Fade, Grid, Typography } from '@mui/material';

import { ILessonHistory } from '../../../../../../../../store/V2/LessonHistorySlice';
import LessonHistoryUserCard from '../components/LessonHistoryUserCard';

interface StudentsTabProps {
  lessonHistory: ILessonHistory;
}

const StudentsTab: FunctionComponent<StudentsTabProps> = ({
  lessonHistory,
}) => {
  const studentList = lessonHistory.students || [];

  return (
    <Fade in>
      <div>
        <div style={{ marginBottom: '16px' }}>
          <Typography fontWeight={600} fontSize="16px">
            Students
          </Typography>
        </div>
        <div>
          <Grid container columnSpacing="16px" rowSpacing="16px">
            {studentList.map((item) => (
              <Grid item key={item._id} xs={12} sm={6}>
                <LessonHistoryUserCard lessonHistoryUser={item} />
              </Grid>
            ))}
          </Grid>
        </div>
      </div>
    </Fade>
  );
};

export default StudentsTab;
